import {LocaleDictionaryRegistrationPage} from "../../interface/registrationPage";
import {PersonalAgreement} from "./personalAgreement";

export const registrationPage: LocaleDictionaryRegistrationPage = {
    checkBoxCaption1: 'Я даю свое',
    checkBoxCaptionLink: 'согласие на обработку персональных данных и присоединяюсь к электронному взаимодействию',
    checkBoxCaption2: 'и ознакомлен(а)',
    checkBoxCaptionLink2: 'с политикой конфиденциальности',
    agreementTitle: 'Согласие на обработку персональных данных и соглашение об электронном взаимодействии',
    agreementTitle2: 'Политика конфиденциальности',
    agreementText: PersonalAgreement,
    policyLink: 'https://privacypolicy.rudn.ru/pdpap_policy.html',
    personalDataProcessingLink: 'https://privacypolicy.rudn.ru/privacy_policy.html',
}
